function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.array.reverse.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from 'react';
import { Button, Chip, Modal, icons, Tooltip, IconTooltip, AMBER, useId } from '@applyboard/ui-components';
import { useEventTracker } from '@applyboard/ui-utils';
import { Box } from '@material-ui/core';
import { formatDateLocal } from "../../../../../util/datetime";
import { formatFileName } from "../utils";
import { getFileExtensionFromFilename } from "../../../../../util/common";
import useInitialProps from "../../../../../hooks/useInitialProps";
import useDispatch from "../../../../../hooks/useDispatch";
import { loadBaseApplication } from "../../../enhancer";
var DownloadOutlineIcon = icons.DownloadOutlineIcon,
  ErrorOutlineIcon = icons.ErrorOutlineIcon,
  Warning = icons.Warning;
var FileEntry = function FileEntry(_ref) {
  var file_name = _ref.file_name,
    fileId = _ref.fileId,
    onDelete = _ref.onDelete,
    updated_at = _ref.updated_at,
    status = _ref.status,
    url = _ref.url,
    onClickOverride = _ref.onClickOverride,
    preview = _ref.preview,
    selected = _ref.selected,
    mb = _ref.mb,
    documentVerificationResults = _ref.documentVerificationResults,
    requirement = _ref.requirement,
    programId = _ref.programId,
    schoolGroupId = _ref.schoolGroupId,
    RemoveFileDialog = _ref.RemoveFileDialog;
  var dispatch = useDispatch();
  var _useInitialProps = useInitialProps(),
    permissions = _useInitialProps.permissions,
    plagiarismCheckEnabled = _useInitialProps.plagiarismCheckEnabled,
    applicationId = _useInitialProps.id;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    showWarningDialog = _React$useState2[0],
    setShowWarningDialog = _React$useState2[1];
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var fileTooltipId = useId();
  var autoCompleted = ['ielts_verification_service'].includes(requirement.completed_by);
  // we need to support the legacy status 'normal' in this place, because ApplyProof API still returns it in verification results
  // TODO - remove support for the legacy status 'normal' coming from the ApplyProof API by:
  //        - decoupling the documentVerificationResults data from the API response
  //        - OR aligning the ApplyProof API response with the new 'no_decision' status
  var allowRemove = function allowRemove() {
    if (preview) {
      return false;
    }
    if ((status === 'normal' || status === 'no_decision') && permissions !== null && permissions !== void 0 && permissions.fulfil_requirement) {
      return true;
    }
    if (permissions !== null && permissions !== void 0 && permissions.destroy_requirement_attachment_for_pii) {
      return true;
    }
    return false;
  };
  var allowDownload = !preview;
  var formattedFileName = formatFileName(file_name);
  var canViewPlagiarismCheck = plagiarismCheckEnabled && (permissions === null || permissions === void 0 ? void 0 : permissions.view_internal_notices);
  var toolTipTextPerError = getToolTipTextPerError({
    canViewPlagiarismCheck: canViewPlagiarismCheck,
    documentVerificationResults: documentVerificationResults,
    requirement: requirement
  });
  var documentHasError = status === 'disapproved' || toolTipTextPerError.length > 0;
  // we need to support the legacy status 'normal' in this place, because ApplyProof API still returns it in verification results
  // TODO - remove support for the legacy status 'normal' coming from the ApplyProof API by:
  //        - decoupling the documentVerificationResults data from the API response
  //        - OR aligning the ApplyProof API response with the new 'no_decision' status
  var documentHasWarning = !documentHasError && (status === 'normal' || status === 'no_decision');
  var chipTooltipText = "".concat(file_name, ", uploaded: ").concat(updated_at ? formatDateLocal(updated_at, 'MMM DD, YYYY - HH:mm') : '');
  var errorTooltipText = getErrorToolTipText({
    toolTipTextPerError: toolTipTextPerError,
    documentHasWarning: documentHasWarning,
    documentVerificationResults: documentVerificationResults
  });
  documentHasWarning && (documentHasWarning = Boolean(errorTooltipText === null || errorTooltipText === void 0 ? void 0 : errorTooltipText.length));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    flexWrap: "nowrap"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    id: fileTooltipId,
    title: chipTooltipText
  }, /*#__PURE__*/React.createElement(Chip, {
    "aria-describedby": fileTooltipId,
    icon: /*#__PURE__*/React.createElement(ChipIcon, {
      allowDownload: allowDownload,
      documentHasError: documentHasError,
      documentHasWarning: documentHasWarning
    }),
    color: getChipColour({
      documentHasWarning: documentHasWarning,
      documentHasError: documentHasError
    }),
    mr: 1,
    mb: mb,
    component: allowDownload ? 'a' : undefined,
    clickable: true,
    selected: selected,
    href: allowDownload ? url : undefined,
    target: allowDownload ? '_blank' : undefined,
    rel: allowDownload ? 'noopener' : undefined,
    role: allowDownload ? 'link' : undefined,
    disableFocusRipple: false,
    disableRipple: false,
    onClick: function onClick(e) {
      if (onClickOverride) {
        onClickOverride(fileId);
      } else if (allowDownload) {
        trackEvent({
          event: 'Single Application - Applicant Requirements - Clicked File Link',
          data: {
            requirementCategory: requirement.requirement_category,
            requirementTemplateId: requirement.requirement_template_id,
            requirementInstanceId: requirement.id,
            applicationStage: requirement.application_stage,
            school_group_id: schoolGroupId,
            program_id: programId,
            autoCompleted: autoCompleted,
            documentStatus: status
          }
        });
      }
      e.stopPropagation();
    },
    onDelete: allowRemove() ? function (e) {
      // Prevent navigating to link when user tries to delete file
      if (e.type === 'click') {
        e.preventDefault();
        e.stopPropagation();
      }
      setShowWarningDialog(true);
    } : undefined
  }, formattedFileName)), errorTooltipText && !preview && /*#__PURE__*/React.createElement(IconTooltip, {
    title: errorTooltipText,
    ml: -1.5,
    mr: 0.5
  })), permissions !== null && permissions !== void 0 && permissions.destroy_requirement_attachment_for_pii && allowRemove() ? /*#__PURE__*/React.createElement(RemoveFileDialog, {
    applicationId: applicationId,
    requirementId: requirement.id,
    requirementType: requirement.requirement_template_type,
    isOpen: showWarningDialog,
    onOpenChange: setShowWarningDialog,
    attachmentId: fileId,
    fileName: file_name,
    isPiiDeleteSynced: true,
    onConfirmNonPiiDelete: function onConfirmNonPiiDelete() {
      trackEvent({
        event: 'Single Application - Applicant Requirements - Clicked Remove File in Confirmation Modal',
        data: {
          documentStatus: status,
          warningReasons: documentVerificationResults,
          requirementId: requirement.id,
          requirementTemplateId: requirement.requirement_template_id,
          categoryId: requirement.requirement_category,
          filename: file_name,
          fileType: getFileExtensionFromFilename(file_name),
          isPii: false
        }
      });
      setShowWarningDialog(false);
      onDelete();
    },
    onSuccess: ( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
        var successfullyDeletedFiles, requirementStatus;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              successfullyDeletedFiles = _ref2.successfullyDeletedFiles, requirementStatus = _ref2.requirementStatus;
              trackEvent({
                event: 'Single Application - Applicant Requirements - Clicked Remove File in Confirmation Modal',
                data: {
                  documentStatus: status,
                  warningReasons: documentVerificationResults,
                  requirementId: requirement.id,
                  requirementTemplateId: requirement.requirement_template_id,
                  categoryId: requirement.requirement_category,
                  filename: file_name,
                  fileType: getFileExtensionFromFilename(file_name),
                  isPii: true
                }
              });
              dispatch({
                type: 'DELETE_REQUIREMENT_ATTACHMENTS',
                requirementAttachmentIds: successfullyDeletedFiles.map(function (deletedFile) {
                  return deletedFile.id;
                }),
                requirementStatus: requirementStatus,
                requirementId: requirement.id,
                requirementType: requirement.requirement_template_type
              });
              _context.next = 5;
              return loadBaseApplication(applicationId, dispatch);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }())
  }) : /*#__PURE__*/React.createElement(Modal, {
    open: showWarningDialog,
    title: "Are you sure?",
    handleClose: function handleClose() {
      return setShowWarningDialog(false);
    },
    footerButtons: function footerButtons() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        variant: "outlined",
        color: "secondary",
        onClick: function onClick() {
          return setShowWarningDialog(false);
        }
      }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
        color: "primary",
        onClick: function onClick() {
          trackEvent({
            event: 'Single Application - Applicant Requirements - Clicked Remove File in Confirmation Modal',
            data: {
              documentStatus: status,
              warningReasons: documentVerificationResults,
              requirementId: requirement.id,
              requirementTemplateId: requirement.requirement_template_id,
              categoryId: requirement.requirement_category,
              filename: file_name,
              fileType: getFileExtensionFromFilename(file_name)
            }
          });
          setShowWarningDialog(false);
          onDelete();
        }
      }, "Remove File"));
    }
  }, "Are you sure you want to remove ".concat(file_name, "?")));
};
var ChipIcon = function ChipIcon(_ref4) {
  var allowDownload = _ref4.allowDownload,
    documentHasWarning = _ref4.documentHasWarning,
    documentHasError = _ref4.documentHasError;
  if (documentHasError) {
    return /*#__PURE__*/React.createElement(ErrorOutlineIcon, null);
  }
  if (documentHasWarning) {
    return /*#__PURE__*/React.createElement(Warning, {
      fill: AMBER[5]
    });
  }
  if (allowDownload) {
    return /*#__PURE__*/React.createElement(DownloadOutlineIcon, null);
  }
  return null;
};
var getChipColour = function getChipColour(_ref5) {
  var documentHasWarning = _ref5.documentHasWarning,
    documentHasError = _ref5.documentHasError;
  if (documentHasError) {
    return 'negative';
  }
  if (documentHasWarning) {
    return 'warning';
  }
  return 'info';
};
function hasPlagiarismServiceError(documentVerificationResult) {
  return documentVerificationResult.resultCode === 'check_failure' || documentVerificationResult.resultCode === 'check_timeout' || documentVerificationResult.resultCode === 'check_complete' && (!documentVerificationResult.outcome || documentVerificationResult.outcome.some(function (outcome) {
    return outcome.result === 'manual_check_required';
  }));
}
function getPlagiarismToolTipText(_ref6) {
  var errorType = _ref6.errorType,
    expression = _ref6.expression;
  var plagiarismErrorMessages = {
    max_word_count: "Document exceeded the maximum word count ".concat(expression, " set by the school applied to."),
    min_word_count: "Document did not meet the minimum word count ".concat(expression, " words set by the school applied to."),
    max_char_count: "Document exceeded the maximum character count ".concat(expression, " set by the school applied to."),
    min_char_count: "Document did not meet the minimum character count ".concat(expression, " set by the school applied to."),
    max_plagiarism_score: 'Document exceeded Plagiarism Content Limit set by the school applied to.'
  };
  if (plagiarismErrorMessages[errorType]) return plagiarismErrorMessages[errorType];
  return '';
}
function getToolTipTextPerError(_ref7) {
  var canViewPlagiarismCheck = _ref7.canViewPlagiarismCheck,
    documentVerificationResults = _ref7.documentVerificationResults,
    requirement = _ref7.requirement;
  if (!(documentVerificationResults !== null && documentVerificationResults !== void 0 && documentVerificationResults.length)) return [];
  var errorText = [];
  documentVerificationResults.forEach(function (result) {
    if (result.resultCode === 'student_ineligible') {
      errorText.push("The verified scores of this document make this applicant ineligible for this program.");
    }
  });
  var plagiarismResults = documentVerificationResults.filter(function (result) {
    return result.verificationType === 'plagiarism';
  });
  if (canViewPlagiarismCheck && plagiarismResults.length) {
    var _requirement$validati;
    var plagiarismRules = requirement === null || requirement === void 0 ? void 0 : (_requirement$validati = requirement.validation_rules) === null || _requirement$validati === void 0 ? void 0 : _requirement$validati.plagiarism;
    plagiarismResults.forEach(function (result) {
      if (hasPlagiarismServiceError(result)) {
        errorText.push('');
      } else if (result.resultCode === 'check_complete') {
        result.outcome.forEach(function (outcome) {
          if (outcome.result !== 'failed' || !plagiarismRules) return;
          errorText.push(getPlagiarismToolTipText({
            errorType: outcome.validationRule,
            expression: plagiarismRules[outcome.validationRule]
          }));
        });
      }
    });
  }
  return errorText;
}
var getDocumentWarningMessage = function getDocumentWarningMessage(documentVerificationResults) {
  var _documentVerification;
  var warnings = [];

  // Special case handling of plagiarism until we move it in line with everything else
  var outcomes = documentVerificationResults === null || documentVerificationResults === void 0 ? void 0 : (_documentVerification = documentVerificationResults.filter(function (result) {
    var _result$outcome;
    return ((_result$outcome = result.outcome) === null || _result$outcome === void 0 ? void 0 : _result$outcome.length) && result.verificationType !== 'plagiarism';
  })) === null || _documentVerification === void 0 ? void 0 : _documentVerification.flatMap(function (dvr) {
    return dvr.outcome;
  });
  if (outcomes) {
    warnings.push.apply(warnings, _toConsumableArray(outcomes.filter(function (outcome) {
      return outcome.result !== 'passed' && outcome.title;
    }).map(function (outcome) {
      return outcome.title;
    })));
  }
  if (documentVerificationResults !== null && documentVerificationResults !== void 0 && documentVerificationResults.some(function (result) {
    return result.resultCode === 'ielts_score_mismatch';
  })) {
    warnings.push("There is a mismatch between the scores in this document and the \n    ones provided on the student profile. Please review and update the student profile.");
  }
  if (documentVerificationResults !== null && documentVerificationResults !== void 0 && documentVerificationResults.some(function (result) {
    return result.resultCode === 'low_quality';
  })) {
    warnings.push("Document hard to read. Please try uploading a better\n      quality document (e.g. less blurry, larger document).");
  }
  if (documentVerificationResults !== null && documentVerificationResults !== void 0 && documentVerificationResults.some(function (result) {
    return result.resultCode === 'name_not_match';
  })) {
    warnings.push("Missing Student Name. The expected student\u2019s name from the\n      student profile was not found in this document when it was expected.\n      Please ensure this is the correct document.");
  }
  return warnings;
};
function getErrorToolTipText(_ref8) {
  var toolTipTextPerError = _ref8.toolTipTextPerError,
    documentHasWarning = _ref8.documentHasWarning,
    documentVerificationResults = _ref8.documentVerificationResults;
  if (documentHasWarning) {
    toolTipTextPerError.push.apply(toolTipTextPerError, _toConsumableArray(getDocumentWarningMessage(documentVerificationResults)));
  }
  if (toolTipTextPerError.length) {
    var toolTipText = toolTipTextPerError.filter(function (text) {
      return text === null || text === void 0 ? void 0 : text.length;
    });
    return toolTipText.length > 1 ? 'There are multiple errors with this file.' : toolTipText[0];
  }
  return '';
}
export default FileEntry;